import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

function ContactSection() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_w7zcj42",
      "template_axdkwvd",
      form.current,
      "qWjP-U9kbrL44iUr0"
    )
    .then(() => {
      alert("Message Sent Successfully!");
      form.current.reset();
    })
    .catch((error) => {
      console.log(error);
      alert("Failed to send message");
    });
  };

  return (
    <section className="contact-con position-relative">
      <div className="container">

        {/* Heading */}
        <div className="row">
          <div className="col-12">
            <div className="contact_content text-center">
              <h2>
                Get in <span>Touch</span> With US
              </h2>
              <p>
                Reach out and connect with us today for any inquiries or assistance!
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="row">

          {/* LEFT SIDE - INFO */}
          <div className="col-lg-4">
            <div className="contact_info">
              <div className="row">

                {/* Location */}
                <div className="col-12">
                  <div className="contact-box">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon1.png"
                        alt="location"
                        className="img-fluid"
                      />
                    </figure>

                    <div className="content">
                      <h6>Our Location</h6>

                      <a
                        href="https://maps.app.goo.gl/rfo7DosRqHxZPBhE7"
                        className="text-decoration-none text-size-16 mb-0" target="_blank"
                      >
                        Mohan's Plaza 733, <br />Road No. 36, Guttala_Begumpet, 
                        <br />CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033
                      </a>
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="col-12">
                  <div className="contact-box">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon2.png"
                        alt="phone"
                        className="img-fluid"
                      />
                    </figure>

                    <div className="content">
                      <h6>Phone Number</h6>

                      <a
                        href="tel:+917207684455"
                        className="mb-0 text-decoration-none text-size-16"
                      >
                        +91 72076 84455
                      </a>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="col-12">
                  <div className="contact-box mb-0">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon3.png"
                        alt="email"
                        className="img-fluid"
                      />
                    </figure>

                    <div className="content">
                      <h6>Email Us at</h6>

                      <a
                        href="mailto:hello@festivogelato.com"
                        className="mb-0 text-decoration-none text-size-16"
                      >
                        hello@festivogelato.com
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* RIGHT SIDE - FORM */}
          <div className="col-lg-8">
            <div className="contact_form">

              <form
                ref={form}
                onSubmit={sendEmail}
                className="position-relative"
              >

                <div className="form-group input1 float-left">
                  <label htmlFor="fname">First Name</label>

                  <input
                    type="text"
                    className="form_style"
                    name="fname"
                    id="fname"
                    required
                  />
                </div>

                <div className="form-group float-left">
                  <label htmlFor="lname">Last Name</label>

                  <input
                    type="text"
                    className="form_style"
                    name="lname"
                    id="lname"
                    required
                  />
                </div>

                <div className="form-group input1 float-left">
                  <label htmlFor="email">Email address</label>

                  <input
                    type="email"
                    className="form_style"
                    name="email"
                    id="email"
                    required
                  />
                </div>

                <div className="form-group float-left">
                  <label htmlFor="phone">Phone</label>

                  <input
                    type="tel"
                    className="form_style"
                    name="phone"
                    id="phone"
                    required
                  />
                </div>

                <div className="form-group message">
                  <label htmlFor="msg">Message</label>

                  <textarea
                    className="form_style"
                    rows="3"
                    name="msg"
                    id="msg"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  id="submit"
                  className="submit_now text-decoration-none"
                >
                  Submit Now
                  <i className="fa-solid fa-arrow-right"></i>
                </button>

              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ContactSection;